/** Cache/sync admin APIs: sempre Gateway → AdminService (mai chiamate dirette al sito Next). */
import api from "../proxy/config";
import axios from "./axiosConfig";

const getHeaders = () => ({
  Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const handleBackendError = (error, defaultMsg) => {
  if (
    error.response?.status === 500
    || (typeof error.response?.data === "string" && error.response.data.includes("Internal Server Error"))
  ) {
    throw new Error("Si è verificato un problema, riprova più tardi.");
  }
  const backendError = error.response?.data;
  const message = typeof backendError === "string"
    ? backendError
    : (backendError?.message || backendError?.error || defaultMsg);
  throw new Error(message);
};

export async function refreshCategoriesCache() {
  try {
    const response = await axios.post(api.cacheRefreshCategories, {}, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore durante la rigenerazione cache categorie");
    throw error;
  }
}

export async function refreshSelectedProductsCache() {
  try {
    const response = await axios.post(api.cacheRefreshSelectedProducts, {}, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore durante la rigenerazione cache prodotti selezionati");
    throw error;
  }
}

export async function refreshVendorsCache() {
  try {
    const response = await axios.post(api.cacheRefreshVendors, {}, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore durante la rigenerazione cache vendor");
    throw error;
  }
}

export async function refreshBannersCache() {
  try {
    const response = await axios.post(api.cacheRefreshBanners, {}, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore durante l'aggiornamento hero sul sito");
    throw error;
  }
}

export async function getDataFreshnessStatus() {
  const response = await axios.post(api.cacheDataStatus, {}, {
    headers: getHeaders(),
  });
  return response.data;
}

export async function getNextRuntimeStatus() {
  const response = await axios.post(api.runtimeNextStatus, {}, {
    headers: getHeaders(),
  });
  return response.data;
}

export async function syncNextDataFreshness() {
  try {
    const response = await axios.post(api.cacheSyncNextDataStatus, {}, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore durante la sincronizzazione cache Next");
    throw error;
  }
}
